import { render } from "./BasketItems.vue?vue&type=template&id=3bc5bd3c&lang=pug"
import script from "./BasketItems.vue?vue&type=script&lang=js"
export * from "./BasketItems.vue?vue&type=script&lang=js"

import "./BasketItems.vue?vue&type=style&index=0&id=3bc5bd3c&lang=sass"
script.render = render

export default script